import * as React from 'react';
import * as mui from '@mui/material';

import BOOKS from 'constants/BOOKS';

const WIDTH = 130;
interface StoryOptionButtonProps extends mui.StackProps {
	story: string;
	selectedStory: string;
	setSelectedStory: React.Dispatch<React.SetStateAction<string>>;
	name1: string;
	name2: string;
	name3: string;
	character1: string;
	character2: string;
	character3: string;
}

const StoryOptionButton = (props: StoryOptionButtonProps) => {
	const { story, selectedStory, setSelectedStory, name1, name2, name3, character1, character2, character3, ...StackProps } = props;

	const isSelected = story === selectedStory;

	const handleOnClick = () => {
		setSelectedStory(story);
	};

	const { title, kind, cities } = (BOOKS as any)[story];

	return (
		<mui.Stack alignItems='flex-start' {...StackProps} sx={{ ...StackProps.sx }}>
			<mui.Box
				sx={{
					backgroundImage: encodeURI(
						`url(https://faboola-generator-wordpress-ij2yppslba-oa.a.run.app/screenshot/${story}/1?name1=${name1}&name2=${name2}&name3=${name3}&character1=${character1}&character2=${character2}&character3=${character3})`,
					),
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					width: `${WIDTH}px`,
					height: `${Math.round(WIDTH / Math.SQRT2)}px`,
					border: `2px solid ${isSelected ? 'white' : 'transparent'}`,
					borderRadius: 1,
					cursor: 'pointer',
					':hover': { border: `2px solid white` },
					mb: 1,
				}}
				onClick={handleOnClick}
			/>

			<mui.Typography color='#fff' fontWeight='bold'>
				{kind}
			</mui.Typography>
			<mui.Typography color='#fff'>{title}</mui.Typography>
			<mui.Typography variant='caption' color='#fff'>
				{cities}
			</mui.Typography>
		</mui.Stack>
	);
};

export default StoryOptionButton;
